import React, { lazy, Suspense, useState, useEffect } from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaWhatsapp
} from "react-icons/fa";
const ReCAPTCHA = lazy(() => import("react-google-recaptcha"));

function ContactPage() {
  const [form, setForm] = useState({
    nom: "",
    prenom: "",
    telephone: "",
    email: "",
    sujet: "",
    message: "",
  });
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!recaptchaValue) {
      setSuccess(null);
      setError("⚠️ Veuillez cocher le reCAPTCHA pour envoyer votre message.");
      return;
    }
    setError(null);
    setSending(true);
    setSuccess(null);
    const res = await fetch("https://adawall.ma/php/api/contact_form.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const data = await res.json();
    setSending(false);
    setSuccess(data.success ? "Message envoyé !" : data.error || "Erreur.");
    if (data.success)
      setForm({
        nom: "",
        prenom: "",
        telephone: "",
        email: "",
        sujet: "",
        message: "",
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact2-page">
      <div className="contact2-hero-bg">
        <div className="contact2-hero-img-overlay">
          <img
            src="https://adawall.ma/uploads/Contact4.jpg"
            alt="Contact AdaWall"
            className="contact2-hero-img"
            loading="eager"
          />
          <div className="contact2-hero-gradient" />
        </div>
        <div className="contact2-hero-content">
          <h2 className="contact2-title">Contactez-nous</h2>
          <p className="contact2-subtitle">
            Notre équipe est à votre écoute pour répondre à vos besoins.
          </p>
        </div>
      </div>
      <div className="contact2-main">
        {/* Colonne infos */}
        <div className="contact2-infos">
          <h3>Contact direct</h3>
          <div className="contact2-info-block">
            <span className="contact2-info-icon"><FaEnvelope size={22} /></span>
            <div>
              <b>Email</b>
              <div>
                <a href="mailto:contact@adawall.ma">contact@adawall.ma</a>
              </div>
            </div>
          </div>
          <div className="contact2-info-block">
            <span className="contact2-info-icon"><FaPhoneAlt size={22} /></span>
            <div>
              <b>Téléphone</b>
              <div>+212 664 66 46 92</div>
            </div>
          </div>
          <div className="contact2-info-block">
            <span className="contact2-info-icon"><FaMapMarkerAlt size={22} /></span>
            <div>
              <b>Adresse</b>
              <div>Rue Racine Valfleuri, MAARIF Casablanca, Maroc</div>
            </div>
          </div>
          <hr className="contact2-separator" />
          <div className="contact2-socials-label">Suivez-nous</div>
          <div className="contact2-socials">
            <a href="https://www.facebook.com/profile.php?id=61577622317866" target="_blank" rel="noopener noreferrer">
              <FaFacebookF size={20} />
            </a>
            <a href="https://www.instagram.com/adawall_maroc/" target="_blank" rel="noopener noreferrer">
              <FaInstagram size={20} />
            </a>
            <a href="https://www.linkedin.com/company/adawall-maroc/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
              <FaLinkedinIn size={20} />
            </a>
            <a href="https://wa.me/212664664692" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp size={20} />
            </a>
            
          </div>
        </div>
        {/* Colonne formulaire */}
        <div className="contact2-form-col">
          <form className="contact2-form" onSubmit={handleSubmit}>
            <div className="contact2-row">
              <input
                name="nom"
                type="text"
                placeholder="Nom"
                value={form.nom}
                onChange={handleChange}
                required
              />
              <input
                name="prenom"
                type="text"
                placeholder="Prénom"
                value={form.prenom}
                onChange={handleChange}
                required
              />
            </div>
            <div className="contact2-row">
              <input
                name="telephone"
                type="tel"
                pattern="[0-9]*"
                inputMode="numeric"
                placeholder="Téléphone"
                value={form.telephone}
                onChange={handleChange}
                onInput={e => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
              />
              <input
                name="email"
                type="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>
            <input
              name="sujet"
              type="text"
              placeholder="Sujet"
              value={form.sujet}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Message"
              value={form.message}
              onChange={handleChange}
              required
            />
            <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
              <Suspense fallback={
                <div style={{
                  width: 304, height: 78, background: "#f1f3f6",
                  borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center"
                }}>
                  <span style={{ color: "#bfcbe6" }}>Chargement du reCAPTCHA…</span>
                </div>
              }>
                <ReCAPTCHA
                  sitekey="6LfBdpwrAAAAAMK5lKsuHzuLCDkvhnqi8m4JA7Dc"
                  onChange={value => setRecaptchaValue(value)}
                />
              </Suspense>
            </div>
            <button type="submit" disabled={sending || !recaptchaValue}>
              {sending ? "Envoi..." : "Envoyer"}
            </button>
            {success && (
              <div className="contact2-success">
                <span role="img" aria-label="check">✅</span> {success}
              </div>
            )}
            {error && (
              <div className="contact2-error">
                {error}
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactPage;